import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { HttpService } from '../../common/http/http.service';
import { MasterDataDto } from '../../../dtos/get/mastrer-data.dto';
import { isPlatformBrowser } from '@angular/common';
import { IApiResponse } from '../../../dtos/common/api-response.dto';

@Injectable({
  providedIn: 'root',
})
export class MasterDataService {
  constructor(private http: HttpService) {}

  private readonly _countries = new BehaviorSubject<any[]>([]);
  private platformId = inject(PLATFORM_ID);

  countries$ = this._countries.asObservable();

  async load(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const response = await firstValueFrom(
      this.http.get<IApiResponse<MasterDataDto>>('get-master-data'),
    );
    console.log(response);
    this._countries.next(response.data!.countries);
  }

  get countries(): any[] {
    return this._countries.value;
  }
}
